RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.CompanySetFilters = Marionette.LayoutView.extend({

        behaviors: {
            AttributeBuilder: {}
        },

        template: '#shellCompanySetFiltersTemplate',

        ui: {
            manageCompanySets: '.x-manage-company-sets',
            allCompanies: '.x-all-companies',
            userCompanySet: '.x-user-tag',
            tooltips: '[data-toggle="tooltip"]',
            dropdownToggle: '.dropdown-toggle'
        },

        regions: {
            singleCompanySets: '.x-single-company-sets'
        },

        events: {
            'click @ui.manageCompanySets': 'onManageCompanySets',
            'click @ui.allCompanies': 'onAllCompaniesSelected',
            'click @ui.userCompanySet': 'onUserCompanySetSelected'
        },

        modelEvents: {
            'change:companySetDescriptor': 'render',
            'change:focusCompanyId': 'render'
        },

        initialize: function () {
            const me = this;

            me.resetSingleCompanySets();

            me.companySetCollection = me.collection;
            me.collection = new Backbone.Collection();
            me.listenTo(me.companySetCollection, 'remove', me.onCompanySetsUpdated);
            me.listenTo(me.companySetCollection, 'add', me.onCompanySetsUpdated);
            me.listenTo(me.companySetCollection, 'reset', me.onCompanySetsUpdated);
            me.listenTo(me.companySetCollection, 'change:name', me.onCompanySetsUpdated);
            me.listenTo(RivalIQ.state.landscape, 'company:added', function () {
                me.resetSingleCompanySets();
                me.updateCollection();
                me.render();
            });
            me.listenTo(RivalIQ.state.landscape, 'company:remove', function () {
                me.resetSingleCompanySets();
                me.updateCollection();
                me.render();
            });

            me.updateCollection();
        },

        resetSingleCompanySets: function () {
            const me = this;

            const onlyCompanyPrefix = RivalIQ.state.companySets.onlyCompany;
            const singleCompanySets = _.map(RivalIQ.state.landscape.get('companies').toJSON(), (company) => {
                const unescaped = _.unescape(company.name);
                return {
                    id: `${onlyCompanyPrefix}${company.id}`,
                    name: unescaped,
                    companyId: company.id,
                    isUserCompanySet: true,
                    companySetId: `${onlyCompanyPrefix}${company.id}`
                };
            });
            const sortedSingleCompanySets = _.sortBy(singleCompanySets, (set) => {
                return set.name.toLowerCase();
            });

            const collection = me.companySetCollection || me.collection;
            const showOnlyCompanySet = collection.find({
                id: onlyCompanyPrefix
            });
            if (showOnlyCompanySet) {
                showOnlyCompanySet.set('companySets', sortedSingleCompanySets);
            } else {
                collection.add({
                    id: onlyCompanyPrefix,
                    name: 'Show Only',
                    companySets: sortedSingleCompanySets
                });
            }
        },

        templateHelpers: function () {

            const me = this;
            const model = me.model;
            const companySetDescriptor = model.get('companySetDescriptor');
            const collection = me.collection;

            let activeModel;
            let activeModelName;
            if (RivalIQ.state.utils.isOnlyCompanySet(companySetDescriptor)) {
                const onlyCompanyModels = collection.find(function (item) {
                    return (item.get('id') === RivalIQ.state.companySets.onlyCompany);
                });
                activeModel = _.find(onlyCompanyModels.get('companySets'), {
                    id: companySetDescriptor
                });
                activeModelName = `Only ${activeModel?.name}`;
            } else {
                // we have to iterate because a null id breaks .get
                activeModel = collection.find(function (item) {
                    return (item.get('companySetId') === companySetDescriptor);
                });
            }

            activeModel = activeModel || collection.first();
            const result = {
                disabled: me.getOption('disabled'),
                name: activeModelName || activeModel.get('name')
            };

            return result;
        },

        serializeData: function () {
            const me = this;

            const userCompanySets = _.filter(me.companySetCollection.toJSON(), 'isUserCompanySet');
            return {
                activeCompanySetDescriptor: RivalIQ.state.view.get('companySetDescriptor'),
                userCompanySets: userCompanySets
            };
        },

        selectCompanySet: function (activeModel) {
            const me = this;

            const model = me.model;

            // would be nice to keep the company filter dropdown open, but for now just close it
            // without persisting a change
            const attributes = {};
            if (activeModel.id === RivalIQ.state.companySets.onlyCompany) {
                attributes.companySetDescriptor = activeModel.get('companySetId');
            } else if (activeModel.get('isUserCompanySet')) {
                attributes.companySetDescriptor = activeModel.get('companySetId');
            } else {
                attributes.companySetDescriptor = activeModel.id;
            }
            model.set(attributes);

            let trackingCompanySetName = attributes.companySetDescriptor;
            if (RivalIQ.state.utils.isOnlyCompanySet(trackingCompanySetName)) {
                const companyId = RivalIQ.state.utils.getCompanyIdFromSetId(trackingCompanySetName);
                const focusCompanyId = RivalIQ.state.view.get('focusCompanyId');
                if (companyId === focusCompanyId) {
                    trackingCompanySetName = RivalIQ.state.companySets.focus;
                } else {
                    trackingCompanySetName = RivalIQ.state.companySets.onlyCompany;
                }
            }
            // TODO clean up use of tag here
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ActivatedTag, {
                tag: trackingCompanySetName
            });

            // ensure we close top level dropdown when flyout menu option is selected
            me.$el.removeClass('open');
        },

        onCompanySetsUpdated: function () {
            const me = this;

            me.updateCollection();
            me.render();
        },

        updateCollection: function () {
            const me = this;

            me.collection.reset(me.companySetCollection.toJSON());
        },

        onRender: function () {
            const me = this;
            me.updateCollection();

            const singleCompanyModel = RivalIQ.state.companySets.find({
                id: RivalIQ.state.companySets.onlyCompany
            });

            const singleCompanyDropdownView = new views.SingleCompanyDropdownButton({
                model: singleCompanyModel
            });
            singleCompanyDropdownView.on('companySetSelected', model => me.selectCompanySet(model));
            me.singleCompanySets.show(singleCompanyDropdownView);

            me.ui.tooltips.tooltip({
                delay: {
                    show: 1500,
                    hide: 0
                }
            });

            me._showHandler = function (e) {
                const activeCompanySet = RivalIQ.state.view.get('companySetDescriptor');
                if (!RivalIQ.state.utils.isOnlyCompanySet(activeCompanySet)) {
                    $(`.company-set-option.active`).get(0)?.scrollIntoView();
                }
            };
            me.$el.on('shown.bs.dropdown', me._showHandler);
        },

        onDestroy: function () {
            const me = this;

            if (me._showHandler) {
                me.$el.off('shown.bs.dropdown', me._showHandler);
            }
        },

        onShow: function () {
            const me = this;
            if (me.getOption('disabled')) {
                me.$el.popover({
                    trigger: 'hover',
                    placement: 'bottom',
                    container: 'body',
                    content: 'Company filtering is not available in the current view.'
                });
            }
        },

        onManageCompanySets: function () {
            const me = this;

            const view = new App.components.CompanySetManagerContainerView();
            RivalIQ.execute('show:modal', view);
            me.$el.removeClass('open');
        },

        onAllCompaniesSelected: function () {
            const me = this;

            const allCompanies = RivalIQ.state.companySets.find({
                id: null
            });
            me.selectCompanySet(allCompanies);
        },

        onUserCompanySetSelected: function (e) {
            const me = this;

            const companySetId = $(e.currentTarget).data('company-set-id');
            const userCompanySet = RivalIQ.state.companySets.find({
                companySetId: companySetId
            });
            me.selectCompanySet(userCompanySet);
        }
    });
});
